/** CE Data Integration support address. Used by the header Help popover. */
export const SUPPORT_EMAIL = 'itcedi@tnc.org';
